import {TextInputEventHandler} from '../TextInput';

import { 
	func, 
} from 'prop-types';


export default class Container extends TextInputEventHandler {
    static propTypes = {
    	render : func.isRequired,
    	onAddItem : func.isRequired,
    }
    onAddClick = ()=>{
    	const {value, onAddItem} = this.props;
    	if(value!==this.state.value){
    		if(onAddItem){
    			onAddItem(this.state.value);
    			this.setState({value:''});
    		}
    	}
    }
    onKeyPress = (e) =>{
    	if(e.key.toLowerCase()==='enter'){
    		this.onAddClick();
    		e.preventDefault(); // for disable onChange event.
    	}
    };
    render(){
    	const {render} = this.props;
    	return render({
    		value : this.state.value,
    		onChange : this.onChange,
    		onKeyPress : this.onKeyPress,
    		onBlur : this.onBlur,
    		onAddClick : this.onAddClick,
    	});
    }
}